// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	DualDropdown1AutoComplete: 'dual-dropdown-1-auto-complete',
	FireInsuranceCompanyItemDiv: 'fire-insurance-company-item-div',
	CreateCompanyButton: 'create-company-button',
} as const;
